export default class Navigation {
  constructor() {
    this.getDomElements()

    if (!this.dom.menuItems.length || !this.dom.menuTriggers.length || !this.dom.header || !this.dom.menuWrapper) return
    
    this.activeID = null
    this.menuItems = []
    this.init()
  }


  init() {
    this.setupItems()
    this.handleHover()
  }


  setupItems() {
    this.dom.menuTriggers.forEach(trigger => {
      this.menuItems.push({
        id: trigger.dataset.id,
        trigger: trigger,
        item: null
      })
    })

    this.dom.menuItems.forEach(item => {
      let id = item.dataset.id

      this.menuItems.map(element => {
        if (element.id == id) {
          element.item = item
        }
      })
    })
  }


  handleHover() {
    this.menuItems.forEach(elements => {
      elements.trigger.addEventListener('mouseover', (e) => {
        e.stopPropagation()

        if (elements.trigger.classList.contains('is-active')) return  

        // Reset
        this.resetActiveStates()
        
        // Set Trigger to active
        elements.trigger.classList.add('is-active')
        elements.item.classList.add('is-active')

        // Set the header to be open
        this.dom.header.classList.add('is-open')
        
        // Set Height
        elements.item.style.height = 'auto'
        let height = elements.item.scrollHeight
        elements.item.style.height = '0px'


        setTimeout(() => {
          this.dom.menuWrapper.style.height = `${height}px`
        }, 5)

        setTimeout(() => {
          elements.item.style.height = `${height}px`
          elements.item.style.top = 0
          elements.item.style.opacity = 1
          this.activeID = this.id
        }, 225)
      })

      elements.item.addEventListener('mouseover', e => {
        e.stopPropagation()
      })
    })

    this.dom.header.addEventListener('mouseover', () => {
      this.activeID = ''
      this.resetActiveStates()
    })
  }


  resetActiveStates() {
    this.dom.header.classList.remove('is-open')
    this.dom.menuWrapper.style.height = '0px'

    this.menuItems.forEach(item => {
      if (item.id !== this.activeID) {
        item.trigger.classList.remove('is-active')
        item.item.classList.remove('is-active')
        item.item.style.opacity = 0
        item.item.style.top = '-20px'
        item.item.style.height = '0px'
      }
    })
  }


  getDomElements() {
    this.dom = {
      'menuTriggers' : document.querySelectorAll('.js-sub-menu-trigger'),
      'menuItems' : document.querySelectorAll('.js-sub-item'),
      'menuWrapper' : document.querySelector('.js-sub-wrapper'),
      'header' : document.querySelector('.js-header')
    }
  }
}